import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

class BadStatusCodeHook {
    assertStatusCode;
    requestConfig;
    mcsName;
    constructor(params) {
        this.assertStatusCode = params.context.assertStatusCode;
        this.mcsName = params.context.requestedServerName;
        this.requestConfig = params.requestConfig;
    }
    onRequest() { }
    onResponse({ responseStatusCode }) {
        if (!this.assertStatusCode(responseStatusCode)) {
            throw new HttpBadStatusCodeError(`Microservice ${this.mcsName} api ${this.requestConfig.url.origin}${this.requestConfig.url.pathname} answers with not allowed status code: ${responseStatusCode}`, responseStatusCode, `http-api.BadStatusCode.${this.mcsName}`);
        }
    }
    onError() { }
}

export { BadStatusCodeHook };
//# sourceMappingURL=BadStatusCodeHook.mjs.map
